import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React from 'react';
import '../../../utils/responsive.es.js';
import 'body-scroll-lock';
import '../../../hooks/useNotification/useNotification.es.js';
import '../../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import '../../../utils/assertions.es.js';
import '../../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'react-beautiful-dnd';
import 'use-callback-ref';
import { useControlled } from '../../../hooks/useControlled/useControlled.es.js';
import 'nanoid/non-secure';
import { Box } from '../../../primitives/Box/Box.es.js';
import '../../../primitives/Center/styled.es.js';
import '../../../primitives/Group/Group.es.js';
import '../../../primitives/Grid/Grid.es.js';
import '../../../primitives/Level/Level.es.js';
import '../../../primitives/Shelf/Shelf.es.js';
import '../../../primitives/Portal/Portal.es.js';
import '../../../primitives/Hidden/Hidden.es.js';
import '../../../primitives/Media/Media.es.js';
import '../../../primitives/Dialog/Dialog.es.js';
import { VisuallyHidden } from '../../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../../primitives/Popper/Popper.es.js';
import '../../../primitives/DragHandle/DragHandle.es.js';
import '../../../primitives/Pin/Pin.es.js';
import { forwardRef } from '../../../system/forwardRef.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var Root = forwardRef(function (props, ref) {
  var _a = props,
      children = _a.children,
      _a$as = _a.as,
      as = _a$as === void 0 ? "input" : _a$as,
      value = _a.value,
      name = _a.name,
      id = _a.id,
      isCheckedProp = _a.isChecked,
      isIndeterminate = _a.isIndeterminate,
      isDisabled = _a.isDisabled,
      isInvalid = _a.isInvalid,
      onChange = _a.onChange,
      onClick = _a.onClick,
      className = _a.className,
      sx = _a.sx,
      wrapperProps = _a.wrapperProps,
      wrapperRef = _a.wrapperRef,
      rest = __objRest(_a, ["children", "as", "value", "name", "id", "isChecked", "isIndeterminate", "isDisabled", "isInvalid", "onChange", "onClick", "className", "sx", "wrapperProps", "wrapperRef"]);

  var _useControlled = useControlled({
    value: isCheckedProp,
    defaultValue: false
  }),
      isChecked = _useControlled[0],
      setIsChecked = _useControlled[1];

  var handleChange = function handleChange(event) {
    onChange == null ? void 0 : onChange(event);
    setIsChecked(event.currentTarget.checked);
  };

  var handleWrapperClick = function handleWrapperClick(event) {
    return event.stopPropagation();
  };

  return (
    /* @__PURE__ */
    React.createElement(Box, __spreadValues({
      as: "label",
      ref: wrapperRef,
      className: className,
      "data-state": isChecked || isIndeterminate ? "checked" : "unchecked",
      "data-invalid": isInvalid,
      "data-disabled": isDisabled,
      onClick: handleWrapperClick,
      sx: sx
    }, wrapperProps),
    /* @__PURE__ */
    React.createElement(VisuallyHidden, __spreadValues({
      as: as,
      ref: ref,
      type: "checkbox",
      id: id,
      name: name,
      value: value,
      onChange: handleChange,
      onClick: onClick,
      checked: isChecked,
      disabled: isDisabled,
      "aria-invalid": isInvalid,
      "aria-checked": isIndeterminate ? "mixed" : isChecked
    }, rest)), children)
  );
});
var Control = forwardRef(function (props, ref) {
  var _a = props,
      _a$as2 = _a.as,
      as = _a$as2 === void 0 ? "div" : _a$as2,
      rest = __objRest(_a, ["as"]);

  return (
    /* @__PURE__ */
    React.createElement(Box, __spreadValues({
      ref: ref,
      as: as
    }, rest))
  );
});
var Label = forwardRef(function (props, ref) {
  var _a = props,
      children = _a.children,
      rest = __objRest(_a, ["children"]);

  return (
    /* @__PURE__ */
    React.createElement(Box, __spreadValues({
      ref: ref
    }, rest), children)
  );
});
var Description = forwardRef(function (props, ref) {
  var _a = props,
      children = _a.children,
      rest = __objRest(_a, ["children"]);

  return (
    /* @__PURE__ */
    React.createElement(Box, __spreadValues({
      ref: ref
    }, rest), children)
  );
});
var CheckboxPrimitive = Object.assign({}, {
  Root: Root,
  Control: Control,
  Label: Label,
  Description: Description
});
export { CheckboxPrimitive };